export const SmallPictureSuffix = "__small";
export const LargePictureSuffix = "__large";
export const ThumbnailPictureSuffix = "__thumbnail";